import { Component, OnInit, Renderer2, OnDestroy, ViewEncapsulation, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MediasQueryService } from 'src/app/core/services/medias-query.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { UserService } from '../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { PageService } from '../../core/services/page.service';
import { SettingsService } from 'src/app/contexts/settings/settings.service';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-layout-theme',
  templateUrl: './theme.component.html',
  encapsulation: ViewEncapsulation.None
})

export class LayoutThemeComponent implements OnInit, OnDestroy {
  @ViewChild('switchThemeFooter') switchThemeFooterElement: ElementRef;
  @ViewChild('menu') menuElement: ElementRef;
  model: any = {
    themes: {
      light: 'light',
      dark: 'dark',
    },
    theme: 'light',
    darkClass: 'theme-dark'
  };
  mediasQuerySubscription: Subscription;
  favIcon: HTMLLinkElement = document.querySelector('#favicon_16');
  favIcon32: HTMLLinkElement = document.querySelector('#favicon_32');
  page: string | null = null;
  sticky: boolean = false;
  isLoaded: boolean = true;
  elementPosition: number;
  toggleHeight: number;
  menuHeight: number;
  url: string;

  displayHTML: any;

  constructor(
    private renderer: Renderer2,
    private titleService: Title,
    private mediasQueryService: MediasQueryService,
    private pageService: PageService,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    public elementRef: ElementRef,
    public settingsService: SettingsService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private keycloak: KeycloakService
  ) { }

  async ngOnInit() {
    await this.initializeUser();

    this.url = "https://tunapagamentos.com.br";

    this.mediasQuerySubscription = this.mediasQueryService
      .isMobile()
      .subscribe(result => (this.model.isMobile = result));

    // Obtendo parâmetros da rota de forma assíncrona
    const params = await firstValueFrom(this.route.paramMap);
    this.model.partner = params.get('partner');
    this.model.account = params.get('account');
    this.model.merchant = params.get('merchant');

    this.setFavIcons(this.model.partner);
    this.readPreferenceTheme();
    this.setTitleMobile();

    const url = this.router.url;
    await this.loadPage(url);
  }

  // Define os favicons dinamicamente
  private setFavIcons(partner: string) {
    const faviconPath = `/branding/${partner}/console/assets/favicon/favicon-16x16.png`;
    this.favIcon.href = faviconPath;
    this.favIcon32.href = faviconPath;
  }


  async initializeUser() {
    await this.userService.setUser();
    const user = await this.userService.getUser();

    if (user) {
      this.model.user = { ...user, realm: this.keycloak.getKeycloakInstance().realm };
    } else {
      console.error("Usuário não pôde ser carregado.");
    }
  }

  ngOnChanges() {
    console.log(this);
  }

  verify() {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd): void => {
      this.loadPage(event.url);
    });
  }

  // getHtml(): Observable<string> {


  //   return this.http.get('https://console.tuna.uy/branding/' + this.model.partner + '/powered_tuna.html', { responseType: 'text' })
  //     .pipe(
  //       catchError(error => {
  //         return of(''); // Retorna uma string vazia ou um valor padrão
  //       })
  //     );
  // }

  async loadPage(url: string) {

    // this.getHtml().subscribe((response) => { if (response) this.displayHTML = this.sanitizer.bypassSecurityTrustHtml(response) });

    await this.pageService.loadPage(this.model.partner, this.model.account, url).then((response: string) => {
      this.page = response;
      window.setTimeout(() => {
        this.onResize();
      }, 1000);
    });
  }

  seeUrlPayout() {
    window.open("https://tuna.statuspage.io/", "_blank");
  }

  ngDoCheck() {
    if (!localStorage[environment.theme]) {
      localStorage[environment.theme] = this.model.theme;
    }
  }

  home() {
    this.router.navigate([this.model.partner, this.model.account]);
  }

  accountChange(account) {
    this.model.accountSelected = account;
  }

  merchantChange(account) {
    this.model.accountSelected = account;
  }

  activateAccount() {
    this.router.navigate([this.model.partner, this.model.accountSelected.key, 'settings', 'company']);
  }

  seeDetailsPayout() {
    this.router.navigate([this.model.partner, this.model.account, this.model.merchant, 'settings', 'merchant']);
  }

  seeDetailsPayoutPartner() {
    this.router.navigate([this.model.partner, this.model.accountSelected.key, 'payout']);
  }

  getNotifications(merchant) {

    this.model.merchantObj = merchant;

    if (this.model.user.portal == 'merchant') {
      this.model.missingPixType = !this.model.merchantObj.pix_key_type || this.model.merchantObj.pix_key_type == 0;
      if (merchant.payout_status == 'E') {
        this.model.errorPixType = true;
        // this.openPixTypeModal(merchant);

      } else {
        this.model.errorPixType = false;
      }
    }
  }

  setTitleMobile() {
    setTimeout(() => (this.model.title = this.titleService.getTitle()), 300);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(
          () => (this.model.title = this.titleService.getTitle()),
          300
        );
      }
    });
  }

  readPreferenceTheme() {
    if (this.model.user?.theme) {
      this.changeCss(this.model.user?.theme);
    } else {
      this.changeCss(localStorage[environment.theme]);
    }
  }

  setPreferenceTheme(isDarkTheme: boolean) {
    localStorage[environment.theme] = isDarkTheme
      ? this.model.themes.dark
      : this.model.themes.light;
    this.updateUserTheme(isDarkTheme);
  }

  updateUserTheme(isDarkTheme) {
    var getUser = this.model.user;

    var theme = isDarkTheme
      ? [this.model.themes.dark]
      : [this.model.themes.light];
    var user = {
      attributes: {
        theme: theme
      }
    }

    this.settingsService.updateTheme(this.model.partner, this.model.account, user).subscribe(response => {
      if (response) {
        localStorage['theme'] = theme;
        this.model.user.theme = theme;
        this.readPreferenceTheme();
        this.userService.setUser();
      }
    },
      (error) => {
      });
  }

  changeCss(theme: string) {
    if (theme == 'undefined') {
      this.model.theme = "light";
    } else {
      this.model.theme = theme ?? this.model.themes.light;
    }
    this.model.isDarkTheme = theme == this.model.themes.dark;
    this.model.isDarkTheme
      ? this.renderer.addClass(document.body, this.model.darkClass)
      : this.renderer.removeClass(document.body, this.model.darkClass);
  }

  ngOnDestroy() {
    this.mediasQuerySubscription.unsubscribe();
  }

  test2(value) {
    this.model.user = this.userService.getUser();
  }

  themeMenuScroll() {
    // if (this.switchThemeFooterElement) {
    //     if (this.switchThemeFooterElement.nativeElement) {
    //         this.elementPosition = this.switchThemeFooterElement.nativeElement.offsetTop;
    //         this.menuHeight = this.menuElement.nativeElement.offsetHeight;
    //         const menuFooter = this.switchThemeFooterElement.nativeElement;
    //         const menu = this.menuElement.nativeElement;

    //         if (menu.scrollHeight > menu.clientHeight) {
    //             this.toggleHeight = menuFooter.offsetHeight;
    //         } else {
    //             this.toggleHeight = 0;
    //         }
    //     }
    // }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.themeMenuScroll();
    // if (this.model.isMobile === false) {
    //     this.sticky = true;
    // } else {
    //     this.sticky = false;
    // }
  }
}
